import { deepCopy, shuffle } from "src/utils";
import { QuestionRange } from "./utils";

export interface TriviaQuestion {
  id: string;
  questionText: string;
  isCorrect: (guess: string) => boolean;
  photo: string;
  caption: string;
}

export function createTriviaQuestions(
  questionBank: any[],
  questionRanges: QuestionRange[],
  count: number
): TriviaQuestion[] {
  const questionsPerRange = Math.floor(count / questionRanges.length);
  const numberOfLeftoverQuestions = count % questionRanges.length;

  const possibleQuestions: any = [];
  const chosenQuestions: TriviaQuestion[] = [];

  const copiedQuestionBank = deepCopy(questionBank);
  for (let i = 0; i < questionRanges.length; i++) {
    const currentQuestionRange = questionRanges[i];
    const possibleQuestionsInRange = copiedQuestionBank.slice(
      currentQuestionRange.start,
      currentQuestionRange.end
    );

    // Mutates possibleQuestionsInRange, removing used questions.
    chosenQuestions.push(
      ...addQuestionsToList(
        chosenQuestions.length,
        questionsPerRange,
        possibleQuestionsInRange
      )
    );

    // Save the unused questions to potentially be used to fill out the leftover questions.
    possibleQuestions.push(...possibleQuestionsInRange);
  }

  // If there are any leftover questions needed to reach the goal count, add them now.
  if (numberOfLeftoverQuestions > 0) {
    chosenQuestions.push(
      ...addQuestionsToList(
        chosenQuestions.length,
        numberOfLeftoverQuestions,
        possibleQuestions
      )
    );
  }

  // shuffle the questions, including updating their question
  return shuffle(chosenQuestions);
}

function addQuestionsToList(
  numberOfQuestionsSoFar: number,
  numberOfQuestionsToAdd: number,
  possibleQuestions: {
    id: string;
    question: string;
    answer: string;
    photo: string;
    caption: string;
  }[]
) {
  const chosenQuestions: TriviaQuestion[] = [];
  for (let i = 0; i < numberOfQuestionsToAdd; i++) {
    const questionIndex = Math.floor(Math.random() * possibleQuestions.length);
    const questionData = possibleQuestions[questionIndex];
    possibleQuestions.splice(questionIndex, 1); // remove the question from the pool of available questions.

    const question: TriviaQuestion = {
      id: questionData.id,
      questionText: questionData.question,
      isCorrect: (guess: string) => guess === questionData.answer,
      photo: questionData.photo,
      caption: questionData.caption,
    };

    chosenQuestions.push(question);
  }
  return chosenQuestions;
}
